export const getBackgroundColors = (express_transport: boolean, premium_transport: boolean): string => {
  if (express_transport) {
    return '#f8bfba'
  } else if (premium_transport) {
    return '#fff3b0'
  }
  return ''
}
